export function hasAttr(el, attr) {
  return el.hasAttribute(attr);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/hasAttr.js
// module id = 84
// module chunks = 0